<template>
  <div class="noti-content" :class="classlist">
    <div class="noti-detail">
      <div class="noti-title" @click="showModal(list.id)">
        {{ list.subject }}
      </div>
      <div class="extra-info">
        <div class="time">
          {{ list.createdAt | convertToFromNowFormat }}
        </div>
      </div>
    </div>
    <a-modal
      class="custom-modal video-modal noti-modal"
      v-model="visible"
      :footer="null"
      title=""
    >
      <div class="noti-modal-body">
        <h2>
         {{ list.subject }}
        </h2>
        <span>
          {{ list.createdAt | convertToFromNowFormat }}
        </span>
        <p v-html="getDate(list.expiryDate)"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
const NOTIFICATON_STORE = "notificationStore"

export default {
  name: "NotiDetail",
  props: {
    list: {
      type: Object,
      required: true,
    },
    classlist: {
      type: Object,
      default: () => ({})
    },
    isUpgradeNotification: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    getDate(d){
      return this.list.description.replace('{expiryDate}', moment(new Date(d)).format('dddd, MMMM DD, YYYY  hh:mm A') );
    },
    async markAsRead(id) {
      await this.$store.dispatch(`${NOTIFICATON_STORE}/readNotification`, { id: id })
      await this.$store.dispatch(`${NOTIFICATON_STORE}/readLocalNotifications`, { id: id })
    },
    async markAsReadUpgrade(id) {
      await this.$store.dispatch(`${NOTIFICATON_STORE}/readNotificationUpgrade`, { id: id })
      await this.$store.dispatch(`${NOTIFICATON_STORE}/readLocalNotificationsUpgrade`, { id: id })
    },
    showModal(id) {
      this.visible = true;
      if (!this.list.isRead && !this.isUpgradeNotification)
        this.markAsRead(id)
        
      if(this.isUpgradeNotification && !this.list.isRead)
        this.markAsReadUpgrade(id)
    },
    closeModal() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
.noti-content {
  background: #fbfbfb;
  .noti-detail {
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      width: calc(100% - 60px);
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      left: 50%;
      bottom: 0;
      transform: translate3d(-50%, 0, 0);
    }
    .noti-title {
      cursor: pointer;
      font-family: $content-font;
      font-size: 15px;
      color: #535353;
    }
    .extra-info {
      display: flex;
      align-items: center;
      padding-left: 20px;
      .time {
        width: 75px;
        font-family: $content-font;
        font-size: 12px;
        font-weight: 600;
        color: #196fc7;
        margin-right: 20px;
      }
      .anticon {
        color: #000;
      }
    }
  }
  &.unread {
    background: #efefef;
    .noti-title {
      color: #000;
      font-weight: 600;
    }
  }
}
.noti-modal {
  .ant-modal {
    top: 30px;
  }
  .ant-modal-mask {
    background: rgba(255, 255, 255, 0.7);
  }
  .ant-modal-close {
    display: block;
    top: 20px;
    right: 20px;
    box-shadow: 0 0px 30px 6px rgba(0, 0, 0, 0.13);
    .ant-modal-close-x {
      width: 35px;
      height: 35px;
      line-height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      .anticon {
        font-size: 16px;
        color: #000;
      }
    }
  }
  .ant-modal-body {
    box-shadow: 0 0px 20px 3px rgba(0, 0, 0, 0.13);
  }
  .noti-modal-body {
    padding: 40px 20px;
    h2 {
      font-family: $content-font;
      font-size: 18px;
      font-weight: 600 !important;
      color: $brand-color;
      margin-bottom: 15px !important;
    }
    span {
      display: block;
      font-family: $content-font;
      font-size: 12px;
      color: #29328a;
      font-weight: 600;
      margin-bottom: 30px;
    }
    p {
      font-family: $content-font;
      font-size: 14px;
      font-weight: 400;
      color: #666;
      margin-bottom: 25px !important;
    }
    button {
      background: #293180;
      border: 1px solid #293180;
      color: #fff;
      font-family: $content-font;
      padding: 10px 25px;
      border-radius: 4px;
      font-weight: 500;
      margin-top: 20px;
      &:focus {
        outline: none;
      }
    }
  }
}
@media only screen and (max-width: 575px) {
  .noti-content {
    .noti-detail {
      padding: 15px;
      flex-direction: column-reverse;
      .noti-title {
        font-size: 14px;
      }
      .extra-info {
        justify-content: space-between;
        padding-left: 0;
        width: 100%;
        margin-bottom: 8px;
        .time {
          width: fit-content;
        }
      }
    }
  }
}
</style>
